import { render, staticRenderFns } from "./awardDetail.vue?vue&type=template&id=96eb1e72&scoped=true"
import script from "./awardDetail.vue?vue&type=script&lang=js"
export * from "./awardDetail.vue?vue&type=script&lang=js"
import style0 from "./awardDetail.vue?vue&type=style&index=0&id=96eb1e72&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96eb1e72",
  null
  
)

export default component.exports